import {Injectable} from '@angular/core';
import {WindowProviderService} from './window-provider.service';

@Injectable({
  providedIn: 'root'
})
export class DomainNameParserService {

  private readonly DOMAIN_REGEX = '.*(?=\\.)'; // returns everything before the last dot
  private readonly STATE_VALIDATION_REGEX = '^(IL|TX|OK|NM|MT|MI)$';
  private readonly DEFAULT_STATE = 'DG';
  private state;

  constructor(private windowProviderService: WindowProviderService) {}

  getState(): string {
    if (!this.state) {
      this.state = this.extractStateOrDefault(this.DEFAULT_STATE);
    }
    return this.state;
  }

  private extractStateOrDefault(defaultValue: string): string {
    const hostname = this.windowProviderService.getHostname();
    console.log('Parsing the window location: ' + hostname);
    const domain = hostname.match(this.DOMAIN_REGEX);

    if (domain == null || domain.length !== 1) {
      console.error('Cannot parse the domain name. URL: ' + hostname + '. ' +
        'Returning the default value = "' + defaultValue + '".');
      return defaultValue;
    }
    let state = domain.pop().slice(-2).toUpperCase();
    console.log(state)
    if(state === 'TS'){
      state = 'MI';
    }
    if (!state.match(this.STATE_VALIDATION_REGEX)) {
      console.error('URL does not contain the state part. Possible state values: IL, TX, OK, NM, MT, MI. ' +
        'Returning the default value = "' + defaultValue + '".');
      return defaultValue;
    }

    console.log('Using the state value taken from the window URL: ' + state);
    return state;
  }
}
